import {
  FC, memo, useEffect,
} from 'react';
import { Modal } from 'shared/ui';
import { useFeedback } from '../../hooks/useFeedback';
import { FeedbackInfoSection } from './FeedbackInfoSection';
import styles from './FeedbackDetailModal.module.scss';

interface FeedbackDetailModalProps {
  feedbackId: number | null;
  onClose: () => void;
}

export const FeedbackDetailModal: FC<FeedbackDetailModalProps> = memo(({
  feedbackId,
  onClose,
}) => {
  const { loadFeedbackDetail, feedbackDetail } = useFeedback();

  useEffect(() => {
    if (feedbackId) {
      loadFeedbackDetail(feedbackId);
    }
  }, [feedbackId]);

  return (
    <Modal
      title="Отзыв пользователя"
      open={!!feedbackDetail?.id}
      onCancel={onClose}
      footer={[
        <div key="footer" className={styles.modalFooter}>
          <button type="button" className={styles.closeButton} onClick={onClose}>
            Закрыть
          </button>
        </div>,
      ]}
      width={800}
      destroyOnClose
    >
      <div className={styles.modalContent}>
        {feedbackDetail && (
          <FeedbackInfoSection feedback={feedbackDetail} />
        )}
      </div>
    </Modal>
  );
});

FeedbackDetailModal.displayName = 'FeedbackDetailModal';




